import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { SelfCheckinBasicInfoPluginType } from '@/models/self-checkin/results'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type TabProps = {
  currentTab: 'license' | 'passport'
}

export const Tab: React.FC<TabProps> = ({ currentTab }) => {
  const history = useHistory()
  const { search, state } = useLocation<{
    basicInfo: SelfCheckinBasicInfoPluginType
    identificationFrontImage: string
    identificationBackImage: string
  }>()
  const { t } = useTranslation()

  return (
    <div css={[settingTabContainerStyle, currentTab === 'license' ? licenseTabHeightStyle : passportTabHeightStyle]}>
      <div
        css={currentTab === 'license' ? settingTabActiveStyle : settingTabStyle}
        onClick={() => history.replace({ pathname: '/self-checkin/identity-verify/upload-license', search, state: { ...state } })}
      >
        {t('Japanese nationality')}
      </div>
      <div
        css={currentTab === 'passport' ? settingTabActiveStyle : settingTabStyle}
        onClick={() => history.replace({ pathname: '/self-checkin/identity-verify/upload-passport', search, state: { ...state } })}
      >
        {t('Foreign nationality')}
      </div>
    </div>
  )
}
const centerStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

const settingTabContainerStyle = css({
  display: 'flex',
  width: '100%',
  maxWidth: 'none',
})

// 変更前の表示どおり、11インチでは免許証画面とパスポート画面でタブ高が異なる。
const licenseTabHeightStyle = css({ height: 65 }, createSelfCheckinResponsiveStyle({ landscape13: { height: 70 } }))
const passportTabHeightStyle = css({ height: 61 }, createSelfCheckinResponsiveStyle({ landscape13: { height: 70 } }))

const settingTabStyle = css(
  centerStyle,
  {
    width: '50%',
    height: '100%',
    borderRadius: '10px 10px 0 0',
    background: '#F5F5F5',
    fontSize: 20,
    fontWeight: 'bold',
    color: '#676767',
    '&:hover': {
      cursor: 'pointer',
      opacity: 0.8,
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: 24 },
  }),
)

const settingTabActiveStyle = css(
  centerStyle,
  {
    width: '50%',
    height: '100%',
    borderRadius: '10px 10px 0 0',
    background: '#fff',
    position: 'relative',
    fontWeight: 'bold',
    fontSize: 20,
    color: '#f2a40b',
    '&::after': {
      position: 'absolute',
      bottom: -4,
      left: 0,
      height: 6,
      width: '100%',
      content: '""',
      background: '#fff',
      zIndex: 1,
    },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: 24 },
  }),
)
